export async function initializeMockery(): Promise<void> {
  if (process.env.NODE_ENV !== 'development' || process.env.DEV_TOOLS !== 'true') return;

  const [{ initMockery }, { createScenarios }] = await Promise.all([import('@avalara/mockery'), import('./scenarios')]);

  const scenarios = await createScenarios();
  await initMockery({ scenarios }).initialized;
}
